import { render } from "./OrderSustainabilityConsultation.vue?vue&type=template&id=775aea58"
import script from "./OrderSustainabilityConsultation.vue?vue&type=script&lang=js"
export * from "./OrderSustainabilityConsultation.vue?vue&type=script&lang=js"

import "./OrderSustainabilityConsultation.vue?vue&type=style&index=0&id=775aea58&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__